/**
 * ITER305 · GuestBrandingHeader
 *
 * Persistent dark navy header that sits above every guest tab
 * (Home, Privileges, Card, History, Profile). Provides continuous
 * brand recognition across the guest wallet — the tenant's logo,
 * the outlet name in serif, and the program label in gold.
 *
 * This is *not* the hero (which is only shown on Home). It is a
 * slim always-on bar so the guest never sees a mystery-meat white
 * screen when tab-switching.
 */
import React from 'react';
import { Sparkles } from 'lucide-react';

export default function GuestBrandingHeader({
  outletName,
  programName,
  logoUrl,
  memberName,
}) {
  return (
    <header
      data-testid="guest-branding-header"
      className="sticky top-0 z-30 w-full"
      style={{
        background: 'var(--gradient-hero)',
        borderBottom: '1px solid rgba(255,255,255,0.08)',
        boxShadow: '0 2px 14px rgba(0,0,0,0.28)',
      }}
    >
      <div className="max-w-[480px] mx-auto flex items-center gap-3 px-5 py-3">
        {logoUrl ? (
          <img
            src={logoUrl}
            alt={outletName}
            className="w-10 h-10 rounded-full object-cover bg-white"
            style={{
              boxShadow: '0 2px 8px rgba(0,0,0,0.35)',
              padding: 2,
            }}
          />
        ) : (
          <div
            className="w-10 h-10 rounded-full flex items-center justify-center"
            style={{
              background: 'rgba(255,255,255,0.10)',
              border: '1px solid rgba(255,255,255,0.20)',
            }}
          >
            <Sparkles className="w-4 h-4" style={{ color: 'var(--gold)' }} />
          </div>
        )}
        <div className="flex-1 min-w-0">
          <div
            className="text-[9px] uppercase tracking-[0.24em] font-semibold"
            style={{ color: 'var(--gold)' }}
          >
            {programName || 'Privilege Membership'}
          </div>
          <div
            className="font-serif text-base leading-tight truncate"
            style={{ color: '#FFFFFF' }}
            data-testid="guest-branding-outlet"
          >
            {outletName}
          </div>
        </div>
        {memberName && (
          <div className="text-right hidden sm:block">
            <div
              className="text-[9px] uppercase tracking-[0.22em] font-semibold"
              style={{ color: 'rgba(255,255,255,0.55)' }}
            >
              Member
            </div>
            <div
              className="text-xs font-medium truncate max-w-[90px]"
              style={{ color: '#FFFFFF' }}
            >
              {memberName}
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
